import { render, staticRenderFns } from "./challenge_detail.vue?vue&type=template&id=2a8f33f2&scoped=true"
import script from "./challenge_detail.vue?vue&type=script&lang=js"
export * from "./challenge_detail.vue?vue&type=script&lang=js"
import style0 from "./challenge_detail.vue?vue&type=style&index=0&id=2a8f33f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f33f2",
  null
  
)

export default component.exports